function parsePieceFromStepName(stepName) {
  const match = String(stepName ?? '').match(/arte\s*(\d+)/i);
  if (!match) {
    return null;
  }
  const pieceNumber = Number(match[1]);
  return Number.isFinite(pieceNumber) ? pieceNumber : null;
}

export function getArtPieceNumber(art) {
  if (!art || typeof art !== 'object') {
    return null;
  }
  const pieceNumber = art.pieceNumber ?? art.piece_number;
  return typeof pieceNumber === 'number' ? pieceNumber : null;
}

/** Piece numbers that should show the edit loading overlay in preview. */
export function resolveEditingPieceNumbers(operation) {
  if (
    !operation ||
    operation.family !== 'arts' ||
    operation.status !== 'processing'
  ) {
    return [];
  }

  if (operation.toolName === 'editar_arte_campanha') {
    if (typeof operation.pieceNumber === 'number') {
      return [operation.pieceNumber];
    }
    const fromStep = parsePieceFromStepName(operation.stepName);
    return fromStep ? [fromStep] : [];
  }

  if (operation.toolName === 'editar_artes_lote') {
    const current = operation.currentStep ?? 0;
    const total = operation.totalSteps ?? 0;
    if (current < total) {
      return [current + 1];
    }
    return [];
  }

  return [];
}

export function isArtPieceEditing(pieceNumber, editingPieceNumbers, fallbackEditing = false) {
  if (pieceNumber == null) {
    return Boolean(fallbackEditing);
  }
  if (Array.isArray(editingPieceNumbers) && editingPieceNumbers.length > 0) {
    return editingPieceNumbers.includes(pieceNumber);
  }
  return Boolean(fallbackEditing);
}
